import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild } from '@angular/router';
import { LocalStorageKeys } from '../models/local-storage.model';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

    constructor(private router: Router) { }

    canActivate(): boolean {
        if (!localStorage.getItem(LocalStorageKeys.Token) || !localStorage.getItem(LocalStorageKeys.User)) {
            this.router.navigate(['login']);
            return false;
        }
        return true;
    }

    canActivateChild(): boolean {
        if (!localStorage.getItem(LocalStorageKeys.Token) || !localStorage.getItem(LocalStorageKeys.User)) {
            this.router.navigate(['login']);
            return false;
        }
        return true;
    }
}